import { useEffect, useState } from "react";
import { abschnittHeader, csvHeaderAbs, hiddenColumns } from "../Tabellen/ConstTabKopf/AbschnittKopf";
import GeneralTable from "../Tabellen/GeneralTable";
import './Abschnitte.css';
import DatenLaden from "../Tabellen/DatenLaden";
import AbschnittNeu from "./AbschnittNeu";
import InformationCell from "../Tabellen/InformationCell";
import AbschnittUpdate from "./AbschnittUpdate";
import StammdatenExport from "../Stammdaten/StammdatenExport";

export default function AbschnittLaden({ absInstance, bhfInstance, kreisInstance, zvInstance, eiuInstance, strKatInstance, setTable, goBack }) {
    const [absData, setAbsData] = useState();
    const [bhfList, setBhfList] = useState([]);
    const [bhfStatus, setBhfStatus] = useState({});
    const [query, setQuery] = useState('');
    const [showData, setShowData] = useState([]);
    const [newFilter, setNewFilter] = useState(false);


    useEffect(() => {
        setBhfStatus({});
        absInstance.getAbschnitteAbschnittGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load abschnitte');
                data.forEach(element => {
                    if (element.gueltigVon) {
                        element.gueltigVon = element.gueltigVon.toLocaleDateString();
                    }
                    if (element.gueltigBis) {
                        element.gueltigBis = element.gueltigBis.toLocaleDateString();
                    }
                });
                console.log(data);
                setAbsData(data);
                setShowData(data);
            }
        });
        bhfInstance.getListOfBahnhofsBahnhoflisteGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load bhfListe');
                console.log(data);

                setBhfList(data);
                data.map(bhf => setBhfStatus(pre => ({ ...pre, [bhf.id]: true })));
            }
        });

        // kreisInstance.kreisListeGet((error, data) => {
        //     if (error) {
        //         console.log(error);
        //     } else {
        //         setKreisList(data);
        //     }
        // })
        // zvInstance.zweckverbandListeZweckverbandListeGet((error, data) => {
        //     if (error) {
        //         console.log(error);
        //     } else {
        //         setZvList(data);
        //     }
        // })
        // eiuInstance.getEiuEisenbahninfraunternehmenGet((error, data) => {
        //     if (error) {
        //         console.log(error);
        //     } else {
        //         setEiuList(data);
        //     }
        // })
        // strKatInstance.getStreckenkategorieStreckenkategorieGet((error, data) => {
        //     if (error) {
        //         console.log(error);
        //     } else {
        //         setStrkatList(data);
        //     }
        // })

    }, [absInstance, setAbsData, bhfInstance, setBhfList]);

    const chooseBhf = event => {
        setBhfStatus(pre => ({ ...pre, [event.target.id]: !bhfStatus[event.target.id] }));
    };

    useEffect(() => {
        setNewFilter(false);
    }, [absData])

    useEffect(() => {
        setNewFilter(true);
    }, [bhfStatus])

    const reloadData = () => {
        setAbsData();
        let loading = new Promise((result) => {
            absInstance.getAbschnitteAbschnittGet((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    console.log('>>load abschnitte');
                    data.forEach(element => {
                        if (element.gueltigVon) {
                            element.gueltigVon = element.gueltigVon.toLocaleDateString();
                        }
                        if (element.gueltigBis) {
                            element.gueltigBis = element.gueltigBis.toLocaleDateString();
                        }
                    });
                    setAbsData(data);
                    setShowData(data);
                }
            });
        });
        loading.then(d => {
            setAbsData(d);
            filtering(d);
        });
    }
    const filtering = (data) => {
        setShowData([]);
        setShowFilter(false);
        if (Object.keys(bhfStatus).filter(entry => bhfStatus[entry]).length === 0 || Object.keys(bhfStatus).filter(entry => !bhfStatus[entry]).length === 0) {
            console.log('>>unnötiger Filter');
            setShowData(data);
        } else {
            const chosenBhfs = Object.keys(bhfStatus).filter(bhf => bhfStatus[bhf]);
            console.log("chosenBhfs:", chosenBhfs)
            setShowData(data.filter(bhf => chosenBhfs.includes(`${bhf.idBhfBeginn}`) || chosenBhfs.includes(`${bhf.idBhfEnde}`)));
        }
        setNewFilter(false);
    };

    const chooseAll = event => {
        event.preventDefault();
        Object.keys(bhfStatus).map(bhf => setBhfStatus(pre => ({ ...pre, [bhf]: JSON.parse(event.target.value) })));
    }
    const [showFilter, setShowFilter] = useState(false);

    const commCol = {
        id: "comment",
        Header: "",
        keyword: "info",
        Cell: ({ row }) => (
            <div>
                <InformationCell comment={row.original.kommentar} />
            </div>
        )
    }

    const updateCol = {
        id: "update",
        Header: '',
        keyword: 'Änderungen',
        Cell: ({ row }) => (
            <div>
                <AbschnittUpdate rowEntry={row} reloadData={reloadData} absInstance={absInstance} />
            </div>
        )
    }

    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            von: it.bhfbeginn,
            nach: it.bhfende,
            Distanz: it.distanz,
            Gültigkeitsbeginn: it.gueltigVon,
            Gültigkeitsende: it.gueltigBis,
            Kreis: it.kreis,
            Zweckverband: it.zv,
            Eiu: it.eiu,
            Streckenkategorie: it.strKat,
            Kommentar: it.kommentar
        }))
    }

    return (
        <div>
            <div>
                <AbschnittNeu bhfInstance={bhfInstance}
                    absInstance={absInstance}
                    reloadData={reloadData}
                    kreisInstance={kreisInstance}
                    zvInstance={zvInstance}
                    eiuInstance={eiuInstance}
                    strKatInstance={strKatInstance} />
                <br></br>
            </div>
            <div className="listen-filter">
                <div className="bhf-filter" onMouseLeave={() => setShowFilter(false)}  >
                    <input onMouseEnter={() => setShowFilter(true)} className="listen-filter-input" value={query} placeholder="...nach Bahnhöfen filtern..." onChange={e => setQuery(e.target.value)}></input>
                    {showFilter &&
                        <div className="opened-filter">
                            <div className="filter-bttn-collection">
                                <button className={newFilter ? "bttn-filter new-filter" : "bttn-filter"} onClick={() => filtering(absData)}>Filter anwenden*</button>
                                {Object.keys(bhfStatus).filter(entry => !bhfStatus[entry]).length > 0
                                    ? <button value={true} onClick={chooseAll} className="selectAll">Alle auswählen</button>
                                    : <button value={false} onClick={chooseAll} className="deselectAll">Alle abwählen</button>}
                            </div>
                            <ul type="none" className="auswahl-liste">
                                {bhfList.filter(bhf => bhf.bahnhof.toLowerCase().indexOf(query.toLowerCase()) > -1)
                                    .map(bhf => <li key={bhf.id}><button id={bhf.id} value={bhf.bahnhof} onClick={chooseBhf} className={bhfStatus[bhf.id] ? "bhf bhf-aktiv" : "bhf"}>{bhf.bahnhof}</button></li>)}
                            </ul>
                        </div>
                    }
                </div>
            </div>
            {showData.length > 1 ? <div>
                <GeneralTable data={showData} columns={abschnittHeader} hiddenColumns={hiddenColumns} additionalColumns={[commCol, updateCol]} />
                <StammdatenExport csvedData={csvIt(showData)} csvHeader={csvHeaderAbs} csvFilename={"sd_abschnitt"} />
            </div>
                : <DatenLaden />}
            <aside style={{ fontSize: "small", marginTop: "3em", width: "50%", borderTop: '1px solid darkslategrey', borderBottom: '1px solid darkslategrey' }}>
                <h4 style={{ margin: "0.2em" }}>Anmerkungen</h4>
                <ul type="square">
                    <li>*ODER-Filter, kein UND(!)<br></br>
                        D.h. es werden alle Abschnitte herausgesucht, welche mindestens einen der ausgewählten Bahnhöfe als Start- oder Endbahnhof beinhalten.</li>
                    <li>Abschnitte sind niemals richtungsbezogen! Demnach ist ein Abschnitt von A nach B gleichbedeutend mit Abschnitt B nach A!</li>
                </ul>
            </aside>
        </div>
    );
}